import { TextFieldProps } from "@mui/material";
import ValidatorAutocomplete from "features/forms/ValidatorAutocomplete";
import moment from "moment-timezone";

const zones = moment.tz.names();

function TimezoneSelect(props: TextFieldProps) {
  const { onChange, value, ...rest } = props;

  return (
    <>
      <ValidatorAutocomplete
        value={value}
        name="timezone"
        options={zones.map((zone) => zone)}
        validators={["required"]}
        errorMessages={["Timezone is required"]}
        label={rest.label}
        size={rest.size}
        helperText={rest.helperText}
        onChange={(event) => {
          const value = event.target.value;
          onChange &&
            onChange({
              target: { value },
            } as React.ChangeEvent<HTMLInputElement>);
        }}
      />
    </>
  );
}

export default TimezoneSelect;
